module.exports = __webpack_public_path__ + "assets/img/channels.a6c91ce9.jpg";